(function () {
  var STORAGE_KEY = 'lizzard_engraving_lead_time_v1';
  var DEFAULT_API =
    'https://onlineordermanagmentapi.vercel.app/api/public/engraving-lead-time';

  function readSessionCache() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.label) return null;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  function writeSessionCache(payload) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          label: payload.label,
          days: payload.days,
          updatedAt: payload.updatedAt || new Date().toISOString()
        })
      );
    } catch (_) {
      /* ignore quota / private mode */
    }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setValue(root, text) {
    var el = root.querySelector('[data-elt-value]');
    if (!el) return;

    var raw = String(text || '').trim();
    var match = raw.match(/^([\d.]+)\s*(.*)$/);
    if (!match) {
      el.textContent = raw;
      return;
    }

    var digits = match[1];
    var unit = match[2] || '';
    var html = '';
    for (var i = 0; i < digits.length; i++) {
      var ch = digits.charAt(i);
      if (ch === '.') {
        html += '<span class="engraving-lead-time-note__tile engraving-lead-time-note__tile--dot">.</span>';
      } else {
        html +=
          '<span class="engraving-lead-time-note__tile">' + escapeHtml(ch) + '</span>';
      }
    }
    if (unit) {
      html +=
        '<span class="engraving-lead-time-note__unit">' + escapeHtml(unit) + '</span>';
    }
    el.innerHTML = html;
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-elt-ready') === '1') return;
    root.setAttribute('data-elt-ready', '1');

    var apiUrl = root.getAttribute('data-api-url') || DEFAULT_API;
    var fallback = root.getAttribute('data-fallback') || 'Estimated at checkout';

    var cached = readSessionCache();
    if (cached && cached.label) {
      setValue(root, cached.label);
    }

    fetch(apiUrl, {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.label) throw new Error('No label');
        setValue(root, data.label);
        writeSessionCache(data);
      })
      .catch(function () {
        if (!cached || !cached.label) {
          setValue(root, fallback);
        }
      });
  }

  function initAll() {
    document.querySelectorAll('[data-engraving-lead-time]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-engraving-lead-time]')
      : null;
    if (root) {
      root.removeAttribute('data-elt-ready');
      initRoot(root);
    }
  });
})();
